import SegmentedControl from '../SegmentedControl';
import ActionBar from '../ActionBar';
import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export enum PagePreviewType {
  text = 'text',
  insights = 'insights',
}

interface PageToolbarProps {
  onChangePreviewType: (event: PagePreviewType) => void;
  onDelete: () => void;
  onEdit: () => void;
}

const ToolbarSegmentedControl = styled(SegmentedControl)`
  width: 200px;
`;

export const PageToolbar = (props: PageToolbarProps) => {
  const options = [
    { label: 'Text', value: PagePreviewType.text, default: true },
    { label: 'Insights', value: PagePreviewType.insights },
  ];

  return (
    <Container>
      <ToolbarSegmentedControl name={'page-preview-options'} options={options} setValue={props.onChangePreviewType} />
      <ActionBar onEdit={props.onEdit} onDelete={props.onDelete} />
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageToolbar/index.tsx